import request from "@/api/index";
import xwpxReq from "@/api/xwpxApi";
/* 门户页机构注册接口 */
//生成图片验证码
export function handleQRcode(params) {
    return request({
        url:'/assbe/organization/generatecaptcha',
        method: "get",
        params,
    });
}
//发送短信验证码
export function handleSendsms(data) {
    return request({
        url:'/assbe/organization/sendsms',
        method: "post",
        data,
    });
}
//判断手机号是否存在，及存在时是否存在机构
export function handlePhoneexist(data) {
    return request({
        url:'/assbe/organization/phoneexist',
        method: "post",
        data,
    });
}
//注册账号及机构
export function handleRegister(data) {
    return request({
        url:'/assbe/organization/register',
        method: "post",
        data,
    });
}
//修改密码
export function handleChangepassword(data) {
    return request({
        url:'/assbe/organization/changepassword',
        method: "post",
        data,
    });
}
//机构状态查询接口
export function handleGetCorpStatus(data) {
    return xwpxReq({
        url:'/bmp-xwpx-api/foreign/getCorpStatus',
        method: "post",
        data,
    });
}
//机构状态查询接口
export function handleGetPersonStatus(data) {
    return xwpxReq({
        url:'/bmp-xwpx-api/foreign/getPersonStatus',
        method: "post",
        data,
    });
}